<template>
  <div class="services">
    <div>
      <el-radio
        v-model="form.is_service"
        label="1"
        @change="change"
      >是</el-radio>
      <el-radio
        v-model="form.is_service"
        label="0"
        @change="change"
      >否</el-radio>
    </div>
    <div
      class="services-checkbox"
      v-if="form.is_service == 1"
    >
      <el-checkbox-group
        v-model="form.service_list"
        @change="change"
      >
        <el-checkbox
          label="1"
          v-if="datasourceList.indexOf('酒店服务') !== -1"
        >酒店服务</el-checkbox>
        <el-checkbox
          label="2"
          v-if="datasourceList.indexOf('礼宾服务') !== -1"
        >礼宾服务</el-checkbox>
        <el-checkbox
          label="3"
          v-if="datasourceList.indexOf('停车服务') !== -1"
        >停车服务</el-checkbox>
      </el-checkbox-group>
    </div>
  </div>
</template>

<script>
import mixins from "./mixins";

export default {
  name: "services",
  mixins: [mixins],
  data() {
    return {
      form: {
        service_list: [],
      },
      datasourceList: [],
    };
  },
  created() {
    this.initDatasourceList();
  },
  methods: {
    initDatasourceList() {
      const { question } = this;
      this.datasourceList = question.datasource.split("|");
    },
    change() {
      this.answerChange(this.form);
    },
  },
};
</script>

<style lang="scss" scoped>
.services-checkbox {
  margin-top: 10px;
}
</style>